/** @module csi/heading/TextController */
define([
	"dojo/_base/declare",
	"dijit/form/_TextBoxMixin",
	"csi/html",
	"./InlineController"
], function(declare,_TextBoxMixin,html,InlineController) {

	var LINE_HEIGHT = 25;

	return declare(InlineController, {
		/** @property {number} _availableSpace - amount of space below DOMNode to bottom of screen */
		_availableSpace: null,

		/**
		 * Highlight text when focused
		 * @param {_WidgetBase} editNode
		 */
		onShowEditNode: function(editNode) {
			if (editNode.focusNode) {
				_TextBoxMixin.selectInputText(editNode.focusNode);
			}
		},

		/**
		 * Return amount of available space for popup widget to the bottom of the page if there is enough to fit the widget
		 * @return {number}
		 */
		_getAvailableSpace: function() {
			if (this._availableSpace == null) {
				var n = this.ren.nTextareaLines || 1;
				var necessary = (n * LINE_HEIGHT) + this.DIALOG_PADDING;
				var available = html.getAvailableHeight(this.refNode);
				
				// store result since this call can force DOM to recaluclate styles
				this._availableSpace = (available > necessary) ? available : 0;
			}
			
			return this._availableSpace;
		},

		/**
		 * Return styles to apply to edit widget to best match the size of the cell
		 * @param {number} w - width of cell
		 * @param {number} h - height of cell
		 * @return {Object}
		 */
		_getEditNodeStyles: function(w, h) {
			var availableSpace = this._getAvailableSpace();
			if (availableSpace) {
				h = LINE_HEIGHT;
			}

			var styles = {
				height: h + "px",
				width: w + "px",
				minHeight: LINE_HEIGHT + "px",
				minWidth: "150px"
			};

			// if widget can show multiple lines (textarea), then assign max height. Clamp the height at 250, whether
			// expanding up (availableSpace is 0) or down. If down, then make sure 250 does not exceed availableSpace.
			if (this.ren.nTextareaLines) {
				styles.maxHeight = Math.min(availableSpace || 250, 250) + "px";
			}

			return styles;
		},

		/**
		 * Listen for events on widget
		 * @param {Context} ctx
		 * @param {Obejct} params
		 * @return {_WidgetBase}
		 */
		_toHtmlDynamic: function(ctx, params) {
			var	editNode = this.inherited(arguments);

			if (!this._getAvailableSpace()) {
				editNode.set("bExpandUp", true);
			}

			this._connectEvent(editNode, "onBlur", "_onProcess");
			this._connectEvent(editNode, "onInput", "_onInput");
			this._connectEvent(editNode, "onSelectOption", "_onProcess");

			return editNode;
		}
	});
});